import React, { useEffect, useContext } from "react";
import classes from "../../index.css";
import { useTranslation } from "react-i18next";
import { StoreContext } from "../../store/store";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import Maintenance from "../Maintenance/Maintenance";
import { loadAdobeDTM, getLocale, convertLocaleFormat } from "../../common/utils";
import { useUnibrowContext } from "../../App";
import { mount } from "globalNavigationReact/index";
import Navigation from "../UI/Navigation/Navigation";

const Start = React.lazy(() => import("../Start/Start"));
const Feedback = React.lazy(() => import("../Feedback/Feedback"));
const EmailPreferences = React.lazy(() => import("../EmailPreferences/EmailPreferences"));
const Confirmation = React.lazy(() => import("../Confirmation/Confirmation"));
const VerifyEmail = React.lazy(() => import("../VerifyEmail/VerifyEmail"));
const EmailSignup = React.lazy(() => import("../EmailSignup/EmailSignup"));
const Unsubscribe = React.lazy(() => import("../Unsubscribe/Unsubscribe"));
const SubscriptionConfirmation = React.lazy(() =>
    import("../SubscriptionConfirmation/SubscriptionConfirmation")
);

const PreferencesLayout = (props) => {
    const { state, dispatch } = useContext(StoreContext);
    let { path, url } = useRouteMatch();
    const { t, i18n } = useTranslation();
    const { showUnibrow } = useUnibrowContext();
    useEffect(() => {
        document.title = t("Preferences | NVIDIA");
        loadAdobeDTM();
    }, []);
    useEffect(() => {
        mount({
            //TODO: replace current header with the header from the global-navigation-react project
            //headerElemID: "preferences-header-container",
            showHeader: false,
            footerElemID: "preferences-footer-container",
            showFooter: true,
            //headerConfig: { preventPullUp: true },
            footerConfig: {
                showLegalFooter: true,
                showPageFooter: false,
            },
            mountLocale: convertLocaleFormat(getLocale(), "xx_XX"),
            mountBrand: "preferences",
            injectAEMfont: false,
            APIEndpoint: NVIDIA_NAVBAR_FOOTER_SERVICE_PATH,
        });
    }, []);
    if (UNDER_MAINTENANCE === true) {
        return (
            <div className={classes.preferencesLayout}>
                <Navigation brandName={t("Preferences")} locale={state.locale} />
                {/* TODO: replace current header with the header from the global-navigation-react project*/}
                {/* <div id="preferences-header-container" /> */}
                <Maintenance locale={state.locale} />
                <div id="preferences-footer-container" />
            </div>
        );
    }

    return (
        <div className={classes.preferencesLayout}>
            <Navigation brandName={t("Preferences")} locale={state.locale} />
            {/* TODO: replace current header with the header from the global-navigation-react project*/}
            {/* <div id="preferences-header-container" />
            <Unibrow />
            <BarMessage showUnibrow={showUnibrow} /> */}
            <div className={showUnibrow ? classes.main + " " + classes.withUnibrow : classes.main}>
                <Switch>
                    <Route path={`${path}/start/`} exact component={Start} />
                    <Route path={`${path}/feedback/`} exact component={Feedback} />
                    <Route path={`${path}/confirm/`} exact component={Confirmation} />
                    <Route path={`${path}/verify-email/`} exact component={VerifyEmail} />
                    <Route path={`${path}/email-preferences/`} exact component={EmailPreferences} />
                    <Route path={`${path}/email-signup/`} exact component={EmailSignup} />
                    <Route
                        path={`${path}/subscription-confirm`}
                        exact
                        component={SubscriptionConfirmation}
                    />
                    <Route path={`${path}/email-unsubscribe/`} exact component={Unsubscribe} />
                    <Redirect exact from="/*" to={`${path}/start/`} />
                </Switch>
            </div>
            <div id="preferences-footer-container" />
        </div>
    );
};

export default PreferencesLayout;
